import clsx from 'clsx'
import React from 'react'

type MatchScoreVariant = 'text' | 'icon'

type Props = {
    value: number // 0–100
    className?: string
    variant?: MatchScoreVariant
}

export default function MatchScore({
    value,
    className,
    variant = 'text',
}: Props): React.JSX.Element {
    const clampedVal = Math.max(0, Math.min(value, 100))

    let label = ''
    let backgroundColor = ''
    let textColor = ''
    let icon = ''

    if (clampedVal >= 75) {
        label = 'High match'
        backgroundColor = '#E8F8F5'
        textColor = '#2ECC71'
        icon = '✓'
    } else if (clampedVal >= 50) {
        label = 'Medium match'
        backgroundColor = '#FEF5E7'
        textColor = '#F39C12'
        icon = '–'
    } else {
        label = 'No match'
        backgroundColor = '#F2F4F4'
        textColor = '#5D6D7E'
        icon = '✕'
    }

    const baseClasses =
        'inline-block self-start px-3 py-1 text-sm font-semibold rounded-lg'
    const iconClasses =
        'w-6 h-6 mb-1 flex items-center justify-center rounded-full text-lg self-start'

    return variant === 'icon' ? (
        <div
            className={clsx(iconClasses, className)}
            style={{
                backgroundColor,
                color: textColor,
            }}
        >
            {icon}
        </div>
    ) : (
        <span
            className={clsx(baseClasses, className)}
            style={{
                backgroundColor,
                color: textColor,
            }}
        >
            {label}
        </span>
    )
}
